import React from 'react';
import AddIcon from '@material-ui/icons/Add';
import { Button } from '@material-ui/core';

import PublicationItem from './PublicationItem';
import styled from 'styled-components';

const PublicationsList = ({
  data: publications,
  onAddPublication,
  onChange,
  onDelete,
}) => {
  return (
    <Container>
      <Title>Publicaciones</Title>
      <span>(opcional)</span>
      {publications.map((publication, index) => (
        <PublicationItem
          key={index}
          data={publication}
          index={index}
          onChange={onChange}
          onDelete={onDelete}
        />
      ))}

      {publications.length > 0 &&
        publications[0].name !== '' &&
        publications[0].info !== '' &&
        publications[0].type !== '' && (
          <Button
            variant='contained'
            color='primary'
            startIcon={<AddIcon />}
            onClick={onAddPublication}
          >
            Agregar Publicación
          </Button>
        )}
    </Container>
  );
};

const Container = styled.section`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 95%;
  justify-content: flex-start;
  margin-bottom: 2em;
`;

const Title = styled.h3`
  margin: 0;
  text-transform: uppercase;
`;

export default PublicationsList;
